import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

import "../../css/createSourceModal.css";
import { getB24Url, sendDataB24 } from "../../helpers/Sources/b24/b24Source";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const B24Source = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const language = useSelector((state) => state.languagesState.languages);

    const [b24Name, setb24Name] = useState("");
    const [b24CrmUrl, setb24CrmUrl] = useState("");
    const [b24Btn, setb24Btn] = useState(false);
    const [b24Check, setb24Check] = useState(false);
    const [b24Id, setb24Id] = useState("");
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const sendb24Data = async (data) => {
        setIsButtonLoading(true);
        let newData = {
            name: b24Name,
            state: data?.state,
            code: data?.code,
            usage_types: [4],
            crm_url: b24CrmUrl,
        };
        let response = await sendDataB24(newData);
        if (response.status) {
            setb24Check(true);
            setb24Btn(false);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
            setb24Id(response?.data?.source?.id);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
        setIsButtonLoading(false);
    };

    const handleb24Name = (e) => {
        const inputValue = e.target.value;
        setb24Name(inputValue);
    };

    const handleb24CrmUrl = (e) => {
        const inputValue = e.target.value;
        setb24CrmUrl(inputValue);
        setb24Btn(inputValue !== "" && inputValue !== null);
    };

    const saveCrmMapping = (response) => {
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: language?.delete_swal_modal?.success ?? "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            setb24Btn(false);
            setb24Name("");
            setb24Id("");
            setb24Check(false);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.getTracker) {
                props.addToTracker(b24Id);
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            props?.handleClose(b24Id);
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    return (
        <div>
            {b24Check ? (
                <>
                    <CrmSourceMappingArea
                        sourceId={b24Id}
                        sourceType={"b24"}
                        mappingSuccess={saveCrmMapping}
                        isModal={props?.isModal}
                        hideSaveButton={useHostFooter}
                        registerFooterAction={registerFooterAction}
                    />
                </>
            ) : (
                <>
                    <FormControl
                        className="mb-3 text-field-ui-workaround"
                        style={{ width: "100%" }}
                    >
                        <TextField
                            name="name"
                            label={language?.source_modal?.name ?? "Name"}
                            variant="outlined"
                            onChange={handleb24Name}
                            placeholder={
                                language?.source_modal?.please_write_name ??
                                "Please Write Name"
                            }
                            value={b24Name}
                            required
                        />
                    </FormControl>

                    <FormControl
                        className="mb-3 text-field-ui-workaround"
                        style={{ width: "100%" }}
                    >
                        <TextField
                            name="name"
                            label={language?.source_modal?.crm_url ?? "CRM URL"}
                            onChange={handleb24CrmUrl}
                            placeholder=".bitrix24.com"
                            value={b24CrmUrl}
                            required
                        />
                    </FormControl>

                    <div className="position-relative overflow-hidden z-1">
                        {props.isButtonLoader !== undefined &&
                            props.isButtonLoader && (
                                <div className="circle-loader">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                        <LoginButton
                            code="b24"
                            getAuthUrl={getB24Url}
                            getAuthUrlData={b24CrmUrl}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.url;
                            }}
                            onAuthUrlError={() => {
                                props?.setIsButtonLoader?.(false);
                                setIsButtonLoading(false);
                            }}
                            paramNames={["code"]}
                            onSuccess={sendb24Data}
                            dataTransform={(params) => ({
                                code: params.code,
                                state: params.state,
                            })}
                            logoSrc="/assets/images/typeImages/b24.png"
                            buttonText={
                                language?.buttons?.connect_with_b24 ??
                                "Connect with Bitrix24"
                            }
                            disabled={!b24Btn}
                            isLoadingExternal={
                                isButtonLoading || props?.isButtonLoader
                            }
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default B24Source;
